import { render, staticRenderFns } from "./WidgetCotacoesStats.vue?vue&type=template&id=a40adf4e&"
import script from "./WidgetCotacoesStats.vue?vue&type=script&lang=js&"
export * from "./WidgetCotacoesStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports